// this is the main entry point of our library
// and where the plugin install method will be

import './utils/object-assign-polyfill'
import qs from 'qs'
import { $axios } from './axios'
import checkoutModule from './store/checkout'
import ExpressCheckout from './components/ExpressCheckout'
import AuthModule from './store/auth'
import ExpressCheckoutSettingsModule from './store/expressCheckoutSettings'
import Localize from './filters/localize'

const defaults = {
  selectedDuration: 12,
  durations: [6, 12, 24],
  visibleProducts: [],
  selectedProducts: [],
  combiProducts: {},
  combisDiscounts: {},
  masterCombi: null,
  masterCombiDiscountName: '',
  combisWithSubreports: [],
  fetchProducts: true,
  fetchDiscounts: true,
  fetchUser: true,
  queries: {
    period: 'period',
    report: 'report',
    discount: 'discount'
  }
}

function urlQueryHandler (store) {
  if (typeof window !== 'undefined') {
    const query = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    if (query[store.state.checkout.queries.period]) {
      const duration = parseInt(query[store.state.checkout.queries.period])
      if (store.state.checkout.durations.includes(duration)) store.commit('checkout/SET_SELECTED_DURATION', duration)
    }
    if (query[store.state.checkout.queries.report]) {
      const reports = query[store.state.checkout.queries.report].split(',')
      store.dispatch('checkout/selectProductsBySlug', reports)
    }
    if (query[store.state.checkout.queries.discount]) {
      store.dispatch('checkout/getDiscount', query[store.state.checkout.queries.discount])
    }
  }
}

export default {
  install(vue, opts) {
      vue.filter('localize', Localize)

      const queries = Object.assign(defaults.queries, opts.queries)
      const options = Object.assign(defaults, opts)
      options.queries = queries

      if (options.apiUrl) {
        $axios.defaults.baseURL = options.apiUrl
      }
      // makes axios instance available in templates using this.$axios
      vue.prototype.$axios = $axios
      
      if (!options || !options.store) {
        throw new Error('Please initialise plugin with a Vuex store.')
      }
  
      // Register checkout vuex module 
      options.store.registerModule('checkout', checkoutModule)
      // makes axios instance available inside the store using this.$axios
      options.store.$axios = $axios

      options.store.commit('checkout/SET_SELECTED_DURATION', options.selectedDuration)
      options.store.commit('checkout/SET_DURATIONS', options.durations)
      options.store.commit('checkout/SET_VISIBLE_PRODUCTS', options.visibleProducts)
      options.selectedProducts.forEach((id) => {
        options.store.commit('checkout/SET_SELECTED_PRODUCTS', id)
        if (options.combiProducts[id]) {
          options.combiProducts[id].forEach((subreportId) => {
            options.store.commit('checkout/SET_SELECTED_PRODUCTS', subreportId)
          })
        }
      })
      options.store.commit('checkout/SET_COMBI_PRODUCTS', options.combiProducts)
      options.store.commit('checkout/SET_COMBIS_DISCOUNTS', options.combisDiscounts)
      options.store.commit('checkout/SET_MASTER_COMBI', options.masterCombi)
      options.store.commit('checkout/SET_MASTER_COMBI_DISCOUNT_NAME', options.masterCombiDiscountName)
      options.store.commit('checkout/SET_COMBIS_WITH_SUBREPORTS', options.combisWithSubreports)
      options.store.commit('checkout/SET_QUERIES', options.queries)

      const requests = []
      if (options.fetchProducts) requests.push(options.store.dispatch('checkout/getProducts'))
      if (options.fetchDiscounts) requests.push(options.store.dispatch('checkout/getDiscounts'))
      if (options.fetchUser) requests.push(options.store.dispatch('checkout/getUser'))

      Promise.all(requests)
      .catch((err) => {
        console.log(err)
      })
      .then(() => {
        urlQueryHandler(options.store)
      })
  }
}

const expressCheckoutsDefaults = {
  user: {
    first_name: '',
    last_name: '',
    email: ''
  },
  apiUrl: null,
  accountUrl: '/',
  blogName: ''
}

export const expressCheckouts = {
  install(vue, opts) {
    const options = Object.assign(expressCheckoutsDefaults, opts)

    if (!options || !options.store) {
      throw new Error('Please initialise plugin with a Vuex store.')
    }

    options.store.registerModule('auth', AuthModule)
    options.store.registerModule('expressCheckoutSettings', ExpressCheckoutSettingsModule)
    
    options.store.commit('auth/SET_USER', options.user)
    options.store.commit('expressCheckoutSettings/SET_ACCOUNT_URL', options.accountUrl)
    options.store.commit('expressCheckoutSettings/SET_BLOG_NAME', options.blogName)

    vue.component('express-checkout', ExpressCheckout)

    if (options.apiUrl) {
      $axios.defaults.baseURL = options.apiUrl
    }
    vue.prototype.$axiosCheckout = $axios
    vue.filter('localize', Localize)
    options.store.$axiosCheckout = $axios
  
  }
}